import * as React from "react";
import {
  PlasmicControlHelper,
  DefaultControlHelperProps
} from "./plasmic/main/PlasmicControlHelper";
import {useState} from "react";

export interface ControlHelperProps extends DefaultControlHelperProps {
}

function ControlHelper({...rest}: ControlHelperProps) {
  const [hidden, hide] = useState<boolean>(false);

  return <PlasmicControlHelper
      hidden={hidden}
      root={{
        onClick: () => hidden && hide(false)
      }}
      english={true}
      closeHandle={{
        onClick: () => hide(true)
      }}
      {...rest}
  />;
}

export default ControlHelper;
